/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { AuthService } from './services/AuthService';
import { DeploymentsService } from './services/DeploymentsService';
import { ExchangeAccountsService } from './services/ExchangeAccountsService';
import { FleetService } from './services/FleetService';
import { MarketDataService } from './services/MarketDataService';
import { ResearchService } from './services/ResearchService';
import { StocksService } from './services/StocksService';
import { SystemService } from './services/SystemService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class JmtApi {
    public readonly auth: AuthService;
    public readonly deployments: DeploymentsService;
    public readonly exchangeAccounts: ExchangeAccountsService;
    public readonly fleet: FleetService;
    public readonly marketData: MarketDataService;
    public readonly research: ResearchService;
    public readonly stocks: StocksService;
    public readonly system: SystemService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '0.0.1',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.auth = new AuthService(this.request);
        this.deployments = new DeploymentsService(this.request);
        this.exchangeAccounts = new ExchangeAccountsService(this.request);
        this.fleet = new FleetService(this.request);
        this.marketData = new MarketDataService(this.request);
        this.research = new ResearchService(this.request);
        this.stocks = new StocksService(this.request);
        this.system = new SystemService(this.request);
    }
}

